<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M39.85 13H27V5a1 1 0 00-2 0v8H12.83L11.6 8.47A2 2 0 009.67 7H5.55a1.5 1.5 0 000 3H8.9l5.6 20.53A2 2 0 0016.43 32h18.26a2 2 0 001.89-1.35l5.16-15A2 2 0 0039.85 13zM34 29H17.2l-3.55-13H25v6.29l-2.71-2.7A1 1 0 0020.83 21l4.41 4.41a1 1 0 001.42 0L31.07 21a1 1 0 00-1.41-1.41L27 22.29V16h11.5zM19 35a4.5 4.5 0 104.5 4.5A4.49 4.49 0 0019 35zm0 6a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0119 41zM32 35a4.5 4.5 0 104.5 4.5A4.49 4.49 0 0032 35zm0 6a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0132 41z"/></svg>